import { Component, ViewEncapsulation } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-modal-success',
  templateUrl: './modal-success.component.html',
  styleUrls: ['./modal-success.component.scss'],
  // encapsulation: ViewEncapsulation.None,
})
export class ModalSuccessComponent {
  text: string = '';
  title: string = '';
  icon: string = '';
  showButton: boolean = false;
  buttonText: string = 'Click me';
  buttonAction: (() => void) | null = null;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.text = this.config.data.text;
    this.title = this.config.data.title;
    this.icon = this.config.data.icon;
    this.showButton = this.config.data.showButton || false;
    this.buttonText = this.config.data.buttonText || 'Click me';
    this.buttonAction = this.config.data.buttonAction || null;
  }

  closeModal() {
    this.ref.close();
  }

  isImage(icon: string): boolean {
    return (
      icon.includes('.png') || icon.includes('.jpg') || icon.includes('.jpeg')
    );
  }

  onButtonClick() {
    if (this.buttonAction) {
      this.buttonAction();
    }
    this.closeModal(); // Opcional: cerrar el modal después de ejecutar la acción
  }
}
